<ion-footer class="pos-popup">
  <div class="crossIcon" (click)="cancel()">
    <ion-icon name="close-outline"></ion-icon>
  </div>
  <div class="content">
    <div class="Quantity-header" *ngIf="!showMore">
      <p class="header" *ngIf="unit == 'Kg'">{{'AddQuantity(g/kg)' | language : 'Add Quantity (g/kg)'}}</p>
      <p class="header-quantity" *ngIf="moq && unit == 'Kg'">{{'MinOrderQuantity'|language:'Min Order Quantity'}}
        {{moq}} {{'kg'|language:'kg'}}</p>
      <p class="header" *ngIf="unit == 'Ltr'">{{'AddQuantity(ml/l)' | language : 'Add Quantity (ml/l)'}}</p>
      <p class="header-quantity" *ngIf="moq && unit == 'Ltr'">{{'MinOrderQuantity'|language:'Min Order Quantity'}}
        {{moq}} l</p>
      <p class="header" *ngIf="unit == 'Pcs' ">{{'AddQuantity(Pieces)' | language : 'Add Quantity(Pieces)'}}</p>
      <p class="header-quantity" *ngIf="moq && unit == 'Pcs' ">{{'MinOrderQuantity'|language:'Min Order Quantity'}}
        {{moq}} {{'Pcs'|language:'Pcs'}}</p>
      <p class="header" *ngIf="unit == 'Plt'">{{'AddQuantity(Plates)' | language : 'Add Quantity (Plates)'}}</p>
      <p class="header-quantity" *ngIf="moq && unit == 'Plt'">{{'MinOrderQuantity'|language:'Min Order Quantity'}}
        {{moq}} {{'Pts'|language:'Pts'}}</p>
      <p class="header" *ngIf="unit == 'Gls'">{{'AddQuantity(glass)' | language : 'Add Quantity(glass)'}}</p>
      <p class="header-quantity" *ngIf="moq && unit == 'Gls'">{{'MinOrderQuantity'|language:'Min Order Quantity'}}
        {{moq}} {{'gls'|language:'gls'}}</p>
      <p class="header" *ngIf="unit == 'Pkt'">{{'AddQuantity(Packets)' | language : 'Add Quantity(Packets)'}}</p>
      <p class="header-quantity" *ngIf="moq && unit == 'Pkt'">{{'MinOrderQuantity'|language:'Min Order Quantity'}}
        {{moq}} {{'Pkt'|language:'Pkt'}}</p>
      <!-- For Kgs -->
      <ion-grid *ngIf="unit == 'Kg'">
        <ion-row class="qunatity" color="primary">
          <ion-col size="3" *ngFor="let item of availableQuantityGm">
            <div class="box" (click)="setQuanity(item, 'gm')">
              <ion-img *ngIf="item === 0.005" src="/assets/icon/kg/5-gm.svg" [ngClass]="{'active' : quantity === item}">
              </ion-img>
              <ion-img *ngIf="item === 0.01" src="/assets/icon/kg/10-gm.svg" [ngClass]="{'active' : quantity === item}">
              </ion-img>
              <ion-img *ngIf="item === 0.025" src="/assets/icon/kg/25-gm.svg"
                [ngClass]="{'active' : quantity === item}">
              </ion-img>
              <ion-img *ngIf="item === 0.05" src="/assets/icon/kg/50-gm.svg" [ngClass]="{'active' : quantity === item}">
              </ion-img>
              <ion-img *ngIf="item === 0.1" src="/assets/icon/kg/100-gm.svg" [ngClass]="{'active' : quantity === item}">
              </ion-img>
              <ion-img *ngIf="item === 0.25" src="/assets/icon/kg/250-gm.svg"
                [ngClass]="{'active' : quantity === item}">
              </ion-img>
              <ion-img *ngIf="item === 0.5" src="/assets/icon/kg/500-gm.svg" [ngClass]="{'active' : quantity === item}">
              </ion-img>
              <ion-img *ngIf="item === 0.75" src="/assets/icon/kg/750-gm.svg"
                [ngClass]="{'active' : quantity === item}">
              </ion-img>
            </div>
          </ion-col>
          <ion-col size="3" *ngFor="let item of availableQuantityKg">
            <div class="box" (click)="setQuanity(item, unit)">
              <ion-img *ngIf="item === 1" src="/assets/icon/kg/1-kg.svg" [ngClass]="{'active' : quantity === item}">
              </ion-img>
              <ion-img *ngIf="item === 1.5" src="/assets/icon/kg/1.5-kg.svg" [ngClass]="{'active' : quantity === item}">
              </ion-img>
              <ion-img *ngIf="item === 2" src="/assets/icon/kg/2-kg.svg" [ngClass]="{'active' : quantity === item}">
              </ion-img>
            </div>
          </ion-col>
          <ion-col size="3">
            <div class="box" (click)="toggleMore()">
              <ion-img src="/assets/icon/kg/kg-more.svg"></ion-img>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
      <!-- For Plates -->
      <ion-grid *ngIf="unit == 'Plt'">
        <ion-row class="qunatity" color="primary">
          <ion-col size="3" *ngFor="let item of availableQuantityPlt">
            <div class="box" (click)="setQuanity(item, unit)">
              <ion-img *ngIf="item === 0.25" src="/assets/icon/pcs/one-by-four-pcs.svg"
                [ngClass]="{'active' : quantity === item}">
              </ion-img>
              <ion-img *ngIf="item === 0.5" src="/assets/icon/pcs/one-by-two-pcs.svg"
                [ngClass]="{'active' : quantity === item}">
              </ion-img>
              <ion-img *ngIf="item === 1" src="/assets/icon/pcs/one-pcs.svg" [ngClass]="{'active' : quantity === item}">
              </ion-img>
              <ion-img *ngIf="item === 1.5" src="/assets/icon/pcs/one-one-by-two-pcs.svg"
                [ngClass]="{'active' : quantity === item}">
              </ion-img>
              <ion-img *ngIf="item === 2" src="/assets/icon/pcs/two-pcs.svg" [ngClass]="{'active' : quantity === item}">
              </ion-img>
              <ion-img *ngIf="item === 4" src="/assets/icon/pcs/four-pcs.svg"
                [ngClass]="{'active' : quantity === item}">
              </ion-img>
              <ion-img *ngIf="item === 5" src="/assets/icon/pcs/five-pcs.svg"
                [ngClass]="{'active' : quantity === item}">
              </ion-img>
              <ion-img *ngIf="item === 6" src="/assets/icon/pcs/six-pcs.svg" [ngClass]="{'active' : quantity === item}">
              </ion-img>
              <ion-img *ngIf="item === 8" src="/assets/icon/pcs/eight-pcs.svg"
                [ngClass]="{'active' : quantity === item}">
              </ion-img>
              <ion-img *ngIf="item === 10" src="/assets/icon/pcs/ten-pcs.svg"
                [ngClass]="{'active' : quantity === item}">
              </ion-img>
              <ion-img *ngIf="item === 12" src="/assets/icon/pcs/12-pcs.svg" [ngClass]="{'active' : quantity === item}">
              </ion-img>
            </div>
          </ion-col>
          <ion-col size="3">
            <div class="box" (click)="toggleMore()">
              <ion-img src="/assets/icon/pcs/pcs-more.svg"></ion-img>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
      <!-- For Pices -->
      <ion-grid *ngIf="unit == 'Pcs'">
        <ion-row class="qunatity" color="primary">
          <ion-col size="3" *ngFor="let item of availableQuantityPcs">
            <div class="box" (click)="setQuanity(item, unit)">
              <ion-img *ngIf="item ===0.5" src="/assets/icon/pcs/one-by-two-pcs.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===1" src="/assets/icon/pcs/one-pcs.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===1.5" src="/assets/icon/pcs/one-one-by-two-pcs.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===2" src="/assets/icon/pcs/two-pcs.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===4" src="/assets/icon/pcs/four-pcs.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===5" src="/assets/icon/pcs/five-pcs.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===6" src="/assets/icon/pcs/six-pcs.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===8" src="/assets/icon/pcs/eight-pcs.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===10" src="/assets/icon/pcs/ten-pcs.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===12" src="/assets/icon/pcs/12-pcs.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===15" src="/assets/icon/pcs/15-pcs.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
            </div>
          </ion-col>
          <ion-col size="3">
            <div (click)="toggleMore()" class="box">
              <ion-img src="/assets/icon/pcs/pcs-more.svg"></ion-img>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
      <!-- For Liter -->
      <ion-grid *ngIf="unit == 'Ltr'">
        <ion-row class="qunatity" color="primary">
          <ion-col size="3" *ngFor="let item of availableQuantityMl">
            <div class="box" (click)="setQuanity(item, 'ml')">
              <ion-img *ngIf="item === 0.05" src="/assets/icon/ltr/50-ml.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item === 0.1" src="/assets/icon/ltr/100-ml.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item === 0.2" src="/assets/icon/ltr/200-ml.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item === 0.25" src="/assets/icon/ltr/250-ml.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item === 0.36" src="/assets/icon/ltr/360-ml.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item === 0.5" src="/assets/icon/ltr/500-ml.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item === 0.65" src="/assets/icon/ltr/650-ml.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item === 0.75" src="/assets/icon/ltr/750-ml.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
            </div>
          </ion-col>
          <ion-col size="3" *ngFor="let item of availableQuantityLtr">
            <div class="box" (click)="setQuanity(item, unit)">
              <ion-img *ngIf="item === 1" src="/assets/icon/ltr/1-ltr.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item === 1.5" src="/assets/icon/ltr/1.5-ltr.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item === 2" src="/assets/icon/ltr/2-ltr.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
            </div>
          </ion-col>
          <ion-col size="3">
            <div class="box" (click)="toggleMore()">
              <ion-img src="/assets/icon/ltr/ltr-more.svg"></ion-img>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
      <ion-grid *ngIf="unit == 'Gls'">
        <ion-row class="qunatity" color="primary">
          <ion-col size="3" *ngFor="let item of availableQuantityGls">
            <div class="box" (click)="setQuanity(item, unit)">
              <ion-img *ngIf="item ===1" src="/assets/icon/gls/gls1.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===2" src="/assets/icon/gls/gls2.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===4" src="/assets/icon/gls/gls4.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===6" src="/assets/icon/gls/gls6.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===8" src="/assets/icon/gls/gls8.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===10" src="/assets/icon/gls/gls10.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===12" src="/assets/icon/gls/gls12.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===14" src="/assets/icon/gls/gls14.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===16" src="/assets/icon/gls/gls16.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===20" src="/assets/icon/gls/gls20.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===24" src="/assets/icon/gls/gls24.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
            </div>
          </ion-col>
          <ion-col size="3">
            <div class="box" (click)="toggleMore()" class="box">
              <ion-img src="/assets/icon/gls/glassMore.svg"></ion-img>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
      <ion-grid *ngIf="unit == 'Pkt'">
        <ion-row class="qunatity" color="primary">
          <ion-col size="3" *ngFor="let item of availableQuantityPkt">
            <div class="box" (click)="setQuanity(item, unit)">
              <ion-img *ngIf="item ===1" src="/assets/icon/Pkt/1Packet.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===2" src="/assets/icon/Pkt/2Packet.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===4" src="/assets/icon/Pkt/4Packet.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===6" src="/assets/icon/Pkt/6Packet.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===8" src="/assets/icon/Pkt/8Packet.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===10" src="/assets/icon/Pkt/10Packet.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===12" src="/assets/icon/Pkt/12Packet.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===14" src="/assets/icon/Pkt/14Packet.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===16" src="/assets/icon/Pkt/16Packet.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===18" src="/assets/icon/Pkt/18Packet.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
              <ion-img *ngIf="item ===20" src="/assets/icon/Pkt/20Packet.svg"
                [ngClass]="{'active' : quantity === item}"></ion-img>
            </div>
          </ion-col>
          <ion-col size="3">
            <div class="box" (click)="toggleMore()" class="box">
              <ion-img src="/assets/icon/Pkt/MorePacket.svg"></ion-img>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <ion-grid class="add-quantity-height" fixed *ngIf="showMore">
      <ion-row>
        <ion-col>
          <h4 class="ion-text-center">{{'more' | language : 'More'}}</h4>
        </ion-col>
      </ion-row>
      <div class="inputs">
        <ion-chip color="primary" mode="ios" outline="true" class="chipadd">
          <ion-icon *ngIf="unit=='Kg'" src="./assets/productpricingpageimg/kg.svg" class="symbol"></ion-icon>
          <ion-icon *ngIf="unit=='Ltr'" src="./assets/productpricingpageimg/ph_drop.svg" class="symbol"></ion-icon>
          <ion-icon *ngIf="unit=='Pcs'" src="./assets/productpricingpageimg/pieces.svg" class="symbol"></ion-icon>
          <ion-icon *ngIf="unit=='Plt'" src="./assets/productpricingpageimg/Plates.svg" class="symbol"></ion-icon>
          <ion-icon *ngIf="unit=='Gls'" src="./assets/productpricingpageimg/glass.svg" class="symbol"></ion-icon>
          <ion-icon *ngIf="unit=='Pkt'" src="./assets/productpricingpageimg/Packet.svg" class="symbol"></ion-icon>
          <ion-input [(ngModel)]="quantity" [disabled]="amount" type="number"
            placeholder="{{unit | language: unit}}"></ion-input>
          <span *ngIf="quantity">{{unit |language: unit}}</span>
        </ion-chip>
        <p class="or">
          &nbsp; {{'or'|language:'OR'}} &nbsp;
        </p>
        <ion-chip color="primary" mode="ios" outline="true" class="chipadd">
          <ion-icon src="./assets/productpricingpageimg/rupee-icon.svg" class="symbol"></ion-icon>
          <ion-input [(ngModel)]="amount" [disabled]="quantity" type="number"
            placeholder="{{'amount'|language:'Amount'}}"></ion-input>
        </ion-chip>
      </div>
      <div class="ion-text-center">
        <ion-button expand="full" shape="round" mode="ios" color="primary" (click)="setQuanity(quantity, unit)"
          class="ion-margin-bottom confirm-btn-margin">{{'confirm' | language : 'Confirm'}}</ion-button>
      </div>
    </ion-grid>
  </div>
</ion-footer>